import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

export const { Types, Creators } = createActions({
  barChartRequest: [],
  getBarChart: ['filter'],
  barChartSuccess: ['data'],
  barChartError: ['err']
});

/* Initial State */

export const INITIAL_STATE = Immutable({
  data: {},
  loading: false,
  error: false
});

/* Reducers */

export const request = state => state.merge({ loading: true });

export const success = (state, { data }) => state.merge({ data, error: false, loading: false });

export const error = state => state.merge({ loading: false, error: true });

/* Reducers to types */

export default createReducer(INITIAL_STATE, {
  [Types.BAR_CHART_REQUEST]: request,
  [Types.BAR_CHART_SUCCESS]: success,
  [Types.BAR_CHART_ERROR]: error
});
